import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing20, spacing8 } from 'approot/shared/styles/spacing.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const ImagePreviewStaticActions = styled(Box).attrs({
  $gap: spacing8,
})`
  position: absolute;
  top: ${rem(spacing20)};
  right: ${rem(spacing20)};
  z-index: 1;
`;
